interface PendingToastProps {
  title: string;
  message: string;
}

export const PendingToast = ({ title, message }: PendingToastProps) => {
  return (
    <div className='flex items-center gap-3'>
      <div className='w-16 h-16 flex justify-center items-center bg-[#ffffff] rounded-md'>
        <svg className='w-10 h-10 text-gray-500 animate-spin' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
          <path
            className='opacity-75'
            fill='currentColor'
            d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
          />
        </svg>
      </div>
      <div>
        <h2 className='font-semibold text-primary-600'>{title}</h2>
        <p className='text-primary-400'>{message}</p>
      </div>
    </div>
  );
};
